import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, Transition as _Transition, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/smalt-home-logo.svg'
import _imports_1 from '@/assets/hamburger-menu.svg'
import _imports_2 from '@/assets/close-icon-2.svg'
import _imports_3 from '@/assets/search-redesign.svg'
import _imports_4 from '@/assets/search-redesign-black.svg'
import _imports_5 from '../assets/no-cloud-icon.svg'


const _hoisted_1 = { class: "w-full hidden md:flex" }
const _hoisted_2 = { class: "w-full flex md:hidden" }
const _hoisted_3 = { class: "w-full flex flex-col bg-[#E5E4E2] mt-4 mx-4 p-3 items-center justify-between rounded" }
const _hoisted_4 = { class: "w-full flex items-center justify-between rounded" }
const _hoisted_5 = {
  key: 0,
  class: "w-full"
}
const _hoisted_6 = { class: "flex items-start" }
const _hoisted_7 = { class: "w-full flex flex-col items-center" }
const _hoisted_8 = { class: "w-full flex flex-col lg:flex-row items-center justify-center lg:items-start lg:justify-between" }
const _hoisted_9 = { class: "flex items-center gap-2 relative cursor-default" }
const _hoisted_10 = { class: "custom-select" }
const _hoisted_11 = {
  key: 0,
  class: "fixed top-0 right-0 bottom-0 left-0 bg-black/35 z-20 overflow-y-auto"
}
const _hoisted_12 = { class: "filter w-[540px] max-h-[calc(100vh-55px)] absolute flex flex-col translate-y-[50px] right-[60px] z-50 min-w-[170px] bg-white p-[24px] rounded-lg shadow-sm gap-[12px] cursor-default" }
const _hoisted_13 = { class: "flex items-start justify-between" }
const _hoisted_14 = { class: "text-gray-600" }
const _hoisted_15 = { class: "border-b border-gray-200" }
const _hoisted_16 = { class: "flex items-start justify-between pb-[16px]" }
const _hoisted_17 = { class: "text-base leading-[20px] text-primary-text-color tracking-[0.01rem] font-semibold" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "flex flex-wrap gap-[8px] overflow-y-auto pb-[16px]" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "flex items-start justify-between" }
const _hoisted_22 = { class: "text-lg leading-[20px] text-primary-text-color tracking-[0.01rem] font-semibold" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "flex flex-col h-[453px] overflow-y-auto" }
const _hoisted_25 = { class: "flex flex-wrap gap-2 mb-[16px]" }
const _hoisted_26 = { class: "text-[#443FA0]" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "flex items-center gap-3 pb-[20px]" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = {
  key: 0,
  class: "mb-[8px] text-[#898790]"
}
const _hoisted_33 = {
  key: 1,
  class: "max-h-[319px] overflow-y-auto"
}
const _hoisted_34 = {
  key: 0,
  class: "text-[#7F7ADC] text-[10px] mb-[8px]"
}
const _hoisted_35 = ["value"]
const _hoisted_36 = ["src"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 2,
  class: "h-[319px] flex flex-col items-center py-[40px] text-gray-400 text-sm"
}
const _hoisted_39 = { class: "mt-[12px]" }
const _hoisted_40 = { class: "flex items-center justify-between" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 0,
  class: "mt-28"
}
const _hoisted_43 = {
  key: 1,
  class: "h-[calc(100vh-125px)] overflow-y-auto self-center max-[1507px]:w-full max-[1507px]:items-start p-4"
}

import "/custom.css";
import MainLayout from "@/layouts/MainLayout.vue";
import MainContent from "@/components/MainPage/MainContent.vue";
import { computed, ref, watch, onMounted } from "vue";
import client from "@/utils/axios";
import { Status } from "@/types";
import SpinnerLoader from "@/components/Loaders/SpinnerLoader.vue";
import { useUserStore } from "@/stores/user";
import ViewOptionsFilter from "@/components/Commercial/ViewOptionsFilter.vue";
import MainPageHeader from "@/components/PageHeader/MainPageHeader.vue";
import MobileMenu from "@/components/MainPage/MobileMenu.vue";
import { useTranslate } from "@/composables/useTranslate";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const isFilterMenuOpen = ref(false);
const searchQuery = ref<string>("");
const isLoading = ref(false);
const userStore = useUserStore();
const isMobileMenuOpen = ref<boolean>(false);
let currentLanguage = computed(() => userStore.language);
let lastDatabaseTranslationUpdateTimestamp = computed(
  () => userStore.translationsUpdateTimestamp
);
const isFilterSearchFocused = ref<boolean>(false);

const selectedDate = ref(new Date()); // default to today

const todayDatePicker = ref(false);
const weekDatePicker = ref(false);
const isTodayNavigationActive = computed(() => activeFilter.value === "today");
const isWeekNavigationActive = computed(() => activeFilter.value === "week");

// Fetch data
const allStatuses = ref<Status[]>([]);
const aLLProjects = ref<any>([]);
const activeFilter = ref<any>("");
const selectedStatuses = ref<Status[]>([]);
const customerList = ref<any>([]);
const selectedNames = ref<any>([]);
const customerSearchQuery = ref("");
let activeSelectedNames: any = [];
const activeFilterNames = ref();
const loadedFilterNames = ref();
const { t } = useTranslate();

// View options filter
const activeViewOptions = ref<string[]>(
  userStore.viewOptions ? userStore.viewOptions : []
);
const selectedViewOptions = ref<string[]>(
  userStore.viewOptions ? userStore.viewOptions : []
);

const hasNoMatchingCustomers = computed(() => {
  return Object.keys(groupedCustomers.value).length === 0;
});

const onUpdateViewOpton = (options: string[]) => {
  selectedViewOptions.value = options;
};

const getAllStatuses = async () => {
  try {
    const response = await client.get(
      "/project-statuses?locale=" + currentLanguage.value
    );

    if (response.data) {
      let statuses = response.data.map((item: any) => {
        return {
          ...item,
          isSelected: true,
          isOpen: true,
        };
      });

      const userFilters = userStore.statusFilters;
      statuses = statuses.map((status: any) => {
        if (userFilters.includes(status.name)) {
          status.isSelected = true;
        } else {
          status.isSelected = false;
        }

        return status;
      });

      allStatuses.value = statuses;

      selectedStatuses.value = statuses.filter(
        (status: any) => status.isSelected
      );

      loadedFilterNames.value = statuses.filter(
        (status: any) => status.isSelected
      );
    }
  } catch (error) {
    console.log(error);
  }
};

const getActiveFilter = async () => {
  try {
    if (userStore.filter) {
      if (/^\d{4}-\d{2}-\d{2}$/.test(userStore.filter)) {
        todayDatePicker.value = true;
        selectedDate.value = new Date(userStore.filter);
        activeFilter.value = "today";
      } else if (
        /^\d{4}-\d{2}-\d{2}_to_\d{4}-\d{2}-\d{2}$/.test(userStore.filter)
      ) {
        const [startStr, endStr] = userStore.filter.split("_to_");
        const start = new Date(startStr);
        const end = new Date(endStr);

        if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
          weekDatePicker.value = true;
          selectedStartDate.value = start;
          selectedEndDate.value = end;
          activeFilter.value = "week";
        }

        // Fallback: simple string filter (like "month", "all", etc.)
      } else {
        activeFilter.value = userStore.filter;
      }
    }
  } catch (error) {
    console.log(error);
  }
};

const getActiveSearchFilter = async () => {
  try {
    if (userStore.searchFilter) {
      searchQuery.value = userStore.searchFilter;
    }
  } catch (error) {
    console.log(error);
  }
};

const getActiveNameFilter = async () => {
  try {
    if (userStore.nameFilter) {
      activeSelectedNames = userStore.nameFilter;
      selectedNames.value = userStore.nameFilter;
    }
  } catch (error) {
    console.log(error);
  }
};

const getAllProjects = async () => {
  isLoading.value = true;

  try {
    const response = await client.get("/projects");
    if (response.data) {
      aLLProjects.value = response.data;
    }
    const seen = new Set();
    customerList.value = aLLProjects.value
      .map((project: any) => {
        const customer = project.customer;
        if (!customer?.name) return null;
        return {
          id: customer.id,
          name: customer.name.trim(),
          logo_url: customer.logo_url,
          key: customer.name.trim().toLowerCase(),
        };
      })
      .filter((customer: any) => {
        if (!customer || seen.has(customer.key)) return false;
        seen.add(customer.key);
        return true;
      })
      .sort((a: any, b: any) => a.name.localeCompare(b.name));
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const groupedCustomers = computed(() => {
  const groups = {};
  const query = customerSearchQuery.value.trim().toLowerCase();

  for (const customer of customerList.value) {
    // Only include if name matches search
    if (!query || customer.name.toLowerCase().includes(query)) {
      const letter = customer.name[0].toUpperCase();
      if (!groups[letter]) groups[letter] = [];
      groups[letter].push(customer);
    }
  }

  return groups;
});

const removeCustomer = (name: any) => {
  selectedNames.value = selectedNames.value.filter(
    (selectedName: any) => selectedName !== name
  );
};

const toggleStatusOpen = (statusId: number) => {
  const status = allStatuses.value.find(
    (status: any) => status.id === statusId
  );

  if (status) {
    status.isOpen = !status.isOpen;
  }
};

onMounted(() => {
  getAllStatuses();
  getAllProjects();
  getActiveFilter();
  getActiveSearchFilter();
  getActiveNameFilter();
});

const filteredProjects = computed(() => {
  let results = aLLProjects.value;
  switch (activeFilter.value) {
    case "today": {
      const selected = new Date(selectedDate.value);
      selected.setHours(0, 0, 0, 0); // normalize to start of day

      results = results.filter((project: any) => {
        let match = false;

        project.termins?.forEach((termin: any) => {
          let start = termin.start ? new Date(termin.start) : null;
          let end = termin.end ? new Date(termin.end) : null;

          if (start) start.setHours(0, 0, 0, 0);
          if (end) end.setHours(0, 0, 0, 0);

          const isStartToday = start && start.getTime() === selected.getTime();
          const isEndToday = end && end.getTime() === selected.getTime();
          const isOngoing =
            start &&
            end &&
            start.getTime() < selected.getTime() &&
            end.getTime() > selected.getTime();

          if (isStartToday || isEndToday || isOngoing) {
            match = true;
          }
        });

        return match;
      });
      break;
    }
    case "week": {
      const monday = new Date(selectedStartDate.value);
      const sunday = new Date(selectedEndDate.value);

      // Just to be sure: normalize the range
      monday.setHours(0, 0, 0, 0);
      sunday.setHours(23, 59, 59, 999);

      results = results.filter((project: any) => {
        let match = false;

        project.termins?.forEach((termin: any) => {
          let start: Date | null = null;
          let end: Date | null = null;

          if (termin.start) {
            start = new Date(termin.start);
            start.setHours(0, 0, 0, 0);
          }

          if (termin.end) {
            end = new Date(termin.end);
            end.setHours(0, 0, 0, 0);
          }

          const projectStartsThisWeek = start
            ? start >= monday && start <= sunday
            : false;

          const projectEndsThisWeek = end
            ? end >= monday && end <= sunday
            : false;

          const projectInProgress =
            start && end ? start < sunday && end > monday : false;

          if (
            projectStartsThisWeek ||
            projectEndsThisWeek ||
            projectInProgress
          ) {
            match = true;
          }
        });

        return match;
      });
      break;
    }
    case "abnahme":
      results = results.filter((project: any) => {
        return (
          project.phases?.filter((item: any) => item.status.name === "abnahme")
            .length > 0
        );
      });
      break;
    case "qc":
      results = results.filter((project: any) => {
        return (
          project.phases?.filter((item: any) => item.status.name === "qc")
            .length > 0
        );
      });
      break;
  }

  if (searchQuery.value && searchQuery.value.length > 0) {
    results = results.filter((query: any) => {
      return query.name.toLowerCase().includes(searchQuery.value.toLowerCase());
    });
  }

  return results;
});

function calculateWeek(base: Date) {
  const d = new Date(base);
  d.setHours(0, 0, 0, 0);
  const day = d.getDay(); // 0 (Sun) – 6 (Sat)
  const diff = day === 0 ? -6 : 1 - day;
  const monday = new Date(d);
  monday.setDate(d.getDate() + diff);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return { monday, sunday };
}

const { monday, sunday } = calculateWeek(new Date());
const selectedStartDate = ref(monday);
const selectedEndDate = ref(sunday);

const setActiveFilter = (filter: string) => {
  if (activeFilter.value === filter) {
    activeFilter.value = null;
  } else {
    activeFilter.value = filter;
  }
  onSaveSelectedStatuses();
};

const handleSaveClick = () => {
  onSaveSelectedStatuses();
  isFilterMenuOpen.value = !isFilterMenuOpen.value;
};

function formatDate(date: Date) {
  const safeDate = new Date(date);
  safeDate.setHours(12, 0, 0, 0); // Set time to 12:00 to avoid UTC conversion issues

  const year = safeDate.getFullYear();
  const month = String(safeDate.getMonth() + 1).padStart(2, "0");
  const day = String(safeDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

const onSaveSelectedStatuses = () => {
  selectedStatuses.value = allStatuses.value.filter(
    (status: any) => status.isSelected
  );

  loadedFilterNames.value = allStatuses.value.filter(
    (status: any) => status.isSelected
  );

  // make API request to save selected statuses
  activeFilterNames.value = selectedStatuses.value.map(
    (status: any) => status.name
  );

  const todayFormatted = formatDate(selectedDate.value);
  const weekFormatted = `${formatDate(selectedStartDate.value)}_to_${formatDate(
    selectedEndDate.value
  )}`;

  let activeFilterName;

  if (
    todayDatePicker.value === true &&
    isTodayNavigationActive.value === true
  ) {
    activeFilterName = todayFormatted;
  } else if (
    weekDatePicker.value === true &&
    isWeekNavigationActive.value === true
  ) {
    activeFilterName = weekFormatted;
  } else {
    activeFilterName = activeFilter.value;
  }

  const activeSearchQuery = searchQuery.value;

  activeViewOptions.value = selectedViewOptions.value;

  activeSelectedNames = selectedNames.value;

  client.post(`/user/save-filters`, {
    statusFilters: activeFilterNames.value,
    filter: activeFilterName,
    searchFilter: activeSearchQuery,
    viewOptions: activeViewOptions.value,
    nameFilters: activeSelectedNames,
  });

  userStore.setStatusFilters(activeFilterNames.value);
  userStore.setFilter(activeFilterName);
  userStore.setSearchFilter(activeSearchQuery);
  userStore.setViewOption(activeViewOptions.value);
  userStore.setNameFilter(activeSelectedNames);
};

const closeFilterWindow = () => {
  isFilterMenuOpen.value = false;

  const selectedIds = new Set(loadedFilterNames.value.map((item) => item.id));

  allStatuses.value = allStatuses.value.map((item) => ({
    ...item,
    isSelected: selectedIds.has(item.id),
  }));

  selectedNames.value = activeSelectedNames;

  selectedViewOptions.value = activeViewOptions.value;
};

const onResetSelectedStatuses = () => {
  allStatuses.value.forEach((status: any) => {
    status.isSelected = false;
  });

  selectedNames.value = [];

  selectedViewOptions.value = [];
};

const goToPreviousDay = () => {
  todayDatePicker.value = true;
  const newDate = new Date(selectedDate.value);
  newDate.setDate(newDate.getDate() - 1);
  selectedDate.value = newDate;

  onSaveSelectedStatuses();
};

const goToNextDay = () => {
  todayDatePicker.value = true;
  const newDate = new Date(selectedDate.value);
  newDate.setDate(newDate.getDate() + 1);
  selectedDate.value = newDate;

  onSaveSelectedStatuses();
};

const resetToToday = () => {
  todayDatePicker.value = false;
  selectedDate.value = new Date();

  onSaveSelectedStatuses();
};

function goToPreviousWeek() {
  weekDatePicker.value = true;
  const { monday } = calculateWeek(selectedStartDate.value);
  const prevBase = new Date(monday);
  prevBase.setDate(monday.getDate() - 7);
  const { monday: m, sunday: s } = calculateWeek(prevBase);
  selectedStartDate.value = m;
  selectedEndDate.value = s;
  onSaveSelectedStatuses();
}

function goToNextWeek() {
  weekDatePicker.value = true;
  const { monday } = calculateWeek(selectedStartDate.value);
  const nextBase = new Date(monday);
  nextBase.setDate(monday.getDate() + 7);
  const { monday: m, sunday: s } = calculateWeek(nextBase);
  selectedStartDate.value = m;
  selectedEndDate.value = s;
  onSaveSelectedStatuses();
}

function resetToThisWeek() {
  weekDatePicker.value = false;
  const { monday, sunday } = calculateWeek(new Date());
  selectedStartDate.value = monday;
  selectedEndDate.value = sunday;
  onSaveSelectedStatuses();
}
const onChangeSearch = (value: string) => (searchQuery.value = value);

// Debaunce Timer
let debounceTimer: any;
watch(searchQuery, () => {
  clearTimeout(debounceTimer); // Clear any existing timer
  debounceTimer = setTimeout(() => {
    onSaveSelectedStatuses(); // Call function
  }, 1500);
});

watch(
  currentLanguage,
  async (newLang: any, oldLang: any) => {
    if (newLang && oldLang && newLang !== oldLang) {
      await getAllStatuses();
    }
  },
  { immediate: true }
);

watch(
  lastDatabaseTranslationUpdateTimestamp,
  async (newTimestamp: any, oldTimestamp: any) => {
    if (newTimestamp && oldTimestamp && newTimestamp !== oldTimestamp) {
      await getAllStatuses();
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(MainPageHeader, {
          "is-today-navigation-active": isTodayNavigationActive.value,
          "today-date-picker": todayDatePicker.value,
          "selected-date": selectedDate.value,
          "is-week-navigation-active": isWeekNavigationActive.value,
          "week-date-picker": weekDatePicker.value,
          "selected-start-date": selectedStartDate.value,
          "selected-end-date": selectedEndDate.value,
          "active-filter": activeFilter.value,
          "search-query": searchQuery.value,
          "is-loading": isLoading.value,
          "active-view-list": activeViewOptions.value,
          "active-status-list": selectedStatuses.value,
          "active-names-list": _unref(activeSelectedNames),
          "is-filter-open": isFilterMenuOpen.value,
          onGoToPreviousDay: goToPreviousDay,
          onGoToNextDay: goToNextDay,
          onResetToToday: resetToToday,
          onGoToPreviousWeek: goToPreviousWeek,
          onGoToNextWeek: goToNextWeek,
          onResetToThisWeek: resetToThisWeek,
          onSetActiveFilter: setActiveFilter,
          onOnChangeSearch: onChangeSearch,
          onGetAllProjects: getAllProjects,
          onToggleFilterMenu: _cache[0] || (_cache[0] = ($event: any) => (isFilterMenuOpen.value = !isFilterMenuOpen.value))
        }, null, 8, ["is-today-navigation-active", "today-date-picker", "selected-date", "is-week-navigation-active", "week-date-picker", "selected-start-date", "selected-end-date", "active-filter", "search-query", "is-loading", "active-view-list", "active-status-list", "active-names-list", "is-filter-open"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_RouterLink, {
              to: "/",
              class: "w-[24px] h-[24px] flex items-center justify-center cursor-pointer"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Smalt icon"
                }, null, -1)
              ]))]),
              _: 1
            }),
            (!isMobileMenuOpen.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isMobileMenuOpen.value = !isMobileMenuOpen.value)),
                  class: "w-8 h-8 flex items-center justify-center"
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "Smalt icon"
                  }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "w-8 h-8 flex items-center justify-center",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isMobileMenuOpen.value = !isMobileMenuOpen.value))
                }, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: "Smalt icon"
                  }, null, -1)
                ]))]))
          ]),
          (isMobileMenuOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(MobileMenu, {
                  "is-today-navigation-active": isTodayNavigationActive.value,
                  "today-date-picker": todayDatePicker.value,
                  "selected-date": selectedDate.value,
                  "is-week-navigation-active": isWeekNavigationActive.value,
                  "week-date-picker": weekDatePicker.value,
                  "selected-start-date": selectedStartDate.value,
                  "selected-end-date": selectedEndDate.value,
                  "active-filter": activeFilter.value,
                  "search-query": searchQuery.value,
                  "is-loading": isLoading.value,
                  "active-view-list": activeViewOptions.value,
                  "active-status-list": selectedStatuses.value,
                  "active-names-list": selectedNames.value,
                  onGoToPreviousDay: goToPreviousDay,
                  onGoToNextDay: goToNextDay,
                  onResetToToday: resetToToday,
                  onGoToPreviousWeek: goToPreviousWeek,
                  onGoToNextWeek: goToNextWeek,
                  onResetToThisWeek: resetToThisWeek,
                  onSetActiveFilter: setActiveFilter,
                  onOnChangeSearch: onChangeSearch,
                  onGetAllProjects: getAllProjects
                }, null, 8, ["is-today-navigation-active", "today-date-picker", "selected-date", "is-week-navigation-active", "week-date-picker", "selected-start-date", "selected-end-date", "active-filter", "search-query", "is-loading", "active-view-list", "active-status-list", "active-names-list"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_Transition, { name: "nested" }, {
                  default: _withCtx(() => [
                    (isFilterMenuOpen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)("home.filter_by")), 1),
                                _createElementVNode("img", {
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (closeFilterWindow())),
                                  src: _imports_2,
                                  alt: "Close",
                                  class: "cursor-pointer"
                                })
                              ]),
                              _createVNode(ViewOptionsFilter, {
                                "selected-view-options": selectedViewOptions.value,
                                onOnOptionUpdate: onUpdateViewOpton
                              }, null, 8, ["selected-view-options"]),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("h4", _hoisted_17, [
                                    _createTextVNode(_toDisplayString(_unref(t)("home.by_status")) + " ", 1),
                                    (
                                allStatuses.value.filter(
                                  (status) => status.isSelected
                                ).length > 0
                              )
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, " (" + _toDisplayString(allStatuses.value.filter(
                                  (status) => status.isSelected
                                ).length) + ") ", 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allStatuses.value, (column) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: column.id
                                    }, [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (column.isSelected = !column.isSelected),
                                        class: _normalizeClass([
                                'px-[10px] py-[10px] rounded-[14px] whitespace-nowrap text-sm',
                                column.isSelected
                                  ? 'bg-[#D1CFF7] text-gray-800'
                                  : 'bg-gray-200 text-gray-800',
                              ])
                                      }, _toDisplayString(column.name), 11, _hoisted_20)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("h4", _hoisted_22, [
                                  _createTextVNode(_toDisplayString(_unref(t)("home.by_customer")) + " ", 1),
                                  (selectedNames.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, " (" + _toDisplayString(selectedNames.value.length) + ") ", 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedNames.value, (name) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: name,
                                      class: "flex items-center text-sm bg-[#E8E7FB] text-gray-800 px-[8px] py-[2px] rounded-[7px]"
                                    }, [
                                      _createElementVNode("span", _hoisted_26, _toDisplayString(customerList.value.find((c) => c.name === name)
                                  ?.name), 1),
                                      _createElementVNode("button", {
                                        class: "ml-2 text-[#7F7ADC] focus:outline-none",
                                        onClick: ($event: any) => (removeCustomer(name))
                                      }, " × ", 8, _hoisted_27)
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("form", {
                                    class: _normalizeClass(["w-full h-[30px] rounded-primary-radius px-[10px] border bg-transparent flex items-center hover:bg-[#D3D1CD] gap-1", `${
                              isFilterSearchFocused.value
                                ? 'border-[#393840]'
                                : 'border-[#A7A5AE]'
                            }`])
                                  }, [
                                    (!isFilterSearchFocused.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[11] || (_cache[11] = [
                                          _createElementVNode("img", {
                                            class: "w-4 h-4",
                                            src: _imports_3,
                                            alt: "Search"
                                          }, null, -1)
                                        ]))]))
                                      : _createCommentVNode("", true),
                                    (isFilterSearchFocused.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[12] || (_cache[12] = [
                                          _createElementVNode("img", {
                                            class: "w-4 h-4",
                                            src: _imports_4,
                                            alt: "Search"
                                          }, null, -1)
                                        ]))]))
                                      : _createCommentVNode("", true),
                                    _withDirectives(_createElementVNode("input", {
                                      onFocus: _cache[4] || (_cache[4] = ($event: any) => (isFilterSearchFocused.value = true)),
                                      onBlur: _cache[5] || (_cache[5] = ($event: any) => (isFilterSearchFocused.value = false)),
                                      class: _normalizeClass(["w-full bg-transparent outline-none text-sm font-normal placeholder:text-[#898790]", `${
                                isFilterSearchFocused.value
                                  ? 'text-[#393840]'
                                  : 'text-[#898790]'
                              }`]),
                                      type: "text",
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((customerSearchQuery).value = $event)),
                                      placeholder: _unref(t)('home.search').value
                                    }, null, 42, _hoisted_31), [
                                      [_vModelText, customerSearchQuery.value]
                                    ])
                                  ], 2)
                                ]),
                                (customerSearchQuery.value)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_unref(t)("global.search_results")), 1))
                                  : _createCommentVNode("", true),
                                (!hasNoMatchingCustomers.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedCustomers.value, (customers, letter) => {
                                        return (_openBlock(), _createElementBlock("div", { key: letter }, [
                                          (!customerSearchQuery.value)
                                            ? (_openBlock(), _createElementBlock("h2", _hoisted_34, _toDisplayString(letter), 1))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customers, (customer) => {
                                              return (_openBlock(), _createElementBlock("label", {
                                                key: customer.key,
                                                class: "flex items-center border-b border-gray-200 p-[4px] gap-[8px] mb-[4px]"
                                              }, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  value: customer.name,
                                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedNames).value = $event)),
                                                  class: _normalizeClass([
                                    selectedNames.value.includes(customer.name)
                                      ? 'projects-filter-checkbox-checked'
                                      : 'projects-filter-checkbox',
                                  ])
                                                }, null, 10, _hoisted_35), [
                                                  [_vModelCheckbox, selectedNames.value]
                                                ]),
                                                (customer.logo_url)
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 0,
                                                      src: customer.logo_url,
                                                      alt: "Logo",
                                                      class: "w-full h-[25px] object-contain object-left"
                                                    }, null, 8, _hoisted_36))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(customer.name), 1))
                                              ]))
                                            }), 128))
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                      _cache[13] || (_cache[13] = _createElementVNode("img", {
                                        src: _imports_5,
                                        alt: ""
                                      }, null, -1)),
                                      _createElementVNode("p", _hoisted_39, _toDisplayString(_unref(t)("home.no_search_results")), 1)
                                    ]))
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("button", {
                                  onClick: onResetSelectedStatuses,
                                  class: "text-base leading-5 tracking-[0.01rem] text-primary-text-color font-semibold p-2 rounded-primary-radius border-2 border-[#393840]"
                                }, _toDisplayString(_unref(t)("home.clear_all")), 1),
                                _createElementVNode("button", {
                                  onClick: handleSaveClick,
                                  class: "text-base leading-5 tracking-[0.01rem] text-white font-semibold p-2 rounded-primary-radius border-2 border-[#393840] bg-[#393840]"
                                }, [
                                  _createTextVNode(_toDisplayString(_unref(t)("home.apply_filters")) + " ", 1),
                                  (
                              selectedViewOptions.value.length > 0 ||
                              allStatuses.value.filter((status) => status.isSelected)
                                .length > 0 ||
                              selectedNames.value.length > 0
                            )
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, " (" + _toDisplayString(selectedViewOptions.value.length +
                              allStatuses.value.filter((status) => status.isSelected)
                                .length +
                              selectedNames.value.length) + ") ", 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createVNode(SpinnerLoader)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createVNode(MainContent, {
                  "selected-view-options": activeViewOptions.value,
                  "status-list": selectedStatuses.value,
                  "all-statuses": allStatuses.value,
                  "project-list": filteredProjects.value,
                  "name-filter": _unref(activeSelectedNames),
                  onToggleStatusOpen: toggleStatusOpen
                }, null, 8, ["selected-view-options", "status-list", "all-statuses", "project-list", "name-filter"])
              ]))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})